import { HTTP } from "@/api";

export default {
  getFilters({ state, commit }) {
    if (state.filters.list.length) return;
    commit("isLoading", {
      key: "filters",
      status: true
    });
    return HTTP.get("/filters/").then(res => {
      let { filters, profiles } = res.data;
      commit("fetchFilters", filters);
      commit("fetchProfiles", profiles);
    });
  },
  setFilters({ commit }, filter) {
    commit("filterLoading", true);
    return HTTP.post("/filters", filter)
      .then(res => {
        let data = res.data;
        if (data.success) {
          commit("setFilters", {
            category: filter.category,
            filters: data.filter
          });
        }
      })
      .finally(() => {
        if (filter.category !== "live") commit("filterLoading", false);
      });
  },
  getFilterSettings({ state, commit }, category) {
    if (state.filters[category].length) return;
    let url = `/filters/${category}/settings`;

    commit("isLoading", {
      key: "filter settings",
      status: true
    });

    return HTTP.get(url).then(res => {
      let data = res.data;
      if (data) {
        const list = category ? data[category] : data;
        commit("setFilterSettings", {
          category: category ? category : false,
          filters: Array.isArray(list) ? list : list ? list.filters : []
        });
        return true;
      } else return false;
    });
  },
  setFilterSettings({ state, commit }, filter) {
    commit("filterLoading", true);
    const category = filter.category;
    return HTTP.post("/filters/settings", filter)
      .then(res => {
        let data = res.data;
        if (data.success) {
          const settings = data.settings;
          commit("setFilterSettings", {
            category,
            filters: settings.filters
          });
        }
      })
      .finally(() => {
        const s = state.data.settings.find(c => c.channel === "live");
        if (
          category === "dadbee" ||
          (category === "live" && s.status === false)
        )
          commit("filterLoading", false);
      });
  },
  closeFilters({ commit }, value) {
    commit("closeFilters", value);
  }
};
